module.exports = __webpack_public_path__ + "img/20160410_1811.61408f08.jpeg";